module.exports = __webpack_public_path__ + "static/media/ann.6fcd18f4.png";